import React, { useState, useEffect } from 'react'
import MediaLoad from './../../../media-load/MediaLoad';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Input from './../../../input/Input';

let validateNumber = 0;
const Gallery = ( props ) => {
    let [ load, setLoad ] = useState(false);
    let [ error, setErrors ] = useState(false);
    let [ forceValidate, setForceValidate ] = useState(false);
    let [ runChangeSelectedIndex, setRunChangeSelectedIndex ] = useState(false);
    
    useEffect(() => {
        if(!load && !props.edit) {
            props.onChange({
                items: [],
            }, props.index);
            setLoad(true);
        }
        if(!load) {
            validateNumber = props.validate;
        }
    }, [load])

    useEffect(() => {
        if(!load && props.edit) {
            if(!props.data.items) {
                props.onChange({
                    items: [],
                }, props.index)
            }else{
                checkNullImage();
            }
            setLoad(true);
        }
    }, [load])

    useEffect(() => {
        if(props.validate !== validateNumber) {
            validate();
        }
    }, [props.validate])

    const validate = async() => {
        await setForceValidate(true);
        await wait(100);
        await setForceValidate(false);
        let errors = await checkErrors();
        if(errors) {
            setErrors(true);
        }else{
            setErrors(false);
        }
    }

    const handleRLDDChange = (result) => {
        if (!result.destination) return;
        const items = Array.from(props.data.items);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        saveData(items);
    }

    const addItem = (item) => {
        let newData = [...props.data.items, {
            image: item,
        }]
        saveData(newData);
    }

    const removeItem = (id) => {
        let newData = props.data.items.filter((item, i) => (item.image?.id === id || !item.image) ? false : item);
        saveData(newData);
    }

    const saveData = (data) => {
        props.onChange({
            ...props.data,
            items: data
        }, props.index)
    }

    async function wait(ms) {
        return new Promise(resolve => {
          setTimeout(resolve, ms);
        });
    }

    let checkErrors = () => {
        let result;
        let elements = document.querySelectorAll(`.gallery-${props.index} .error`);
        if( elements.length > 0 ) {
            result = true;
        } else {
            result = false;
        }
        return result;
    }

    const checkNullImage = () => {
        let newData = props.data && props.data.items && props.data.items.filter(item => item.image && item.image.id ? item : false);
        saveData(newData)
    }

    const updateValue = (val, label) => {
        let newData = props.data;
        newData[label] = val;
        props.onChange({
            newData
        })
    }

    const handleKeyDown = (e, functionName, functionValue = false, functionValueSecond = false) => {
        if (e.key === 'Enter' || e.key == 'Escape') {
            functionName(functionValue, functionValueSecond)
        }
    }

    return (
        <div className={error ? `section-wrapper gallery error-section gallery-${props.index}` : `section-wrapper gallery gallery-${props.index}`}>
            <DragDropContext onDragEnd={handleRLDDChange}>
                <Droppable droppableId="section-items" direction="horizontal">
                    {(provided) => (
                        <div className="section-items" {...provided.droppableProps} ref={provided.innerRef}>
                            {props.data && props.data.items && props.data.items.map((item, index) => (
                                <Draggable key={String(index)} draggableId={String(index)} index={index}>
                                    {(provided) => provided && (
                                        <div className="gallery-content" {...provided.draggableProps} ref={provided.innerRef}>
                                            <div className="section-index">
                                                {/* {!error &&
                                                    <i {...provided.dragHandleProps} className="material-icons">open_with</i>
                                                }
                                                <i onClick={() => removeItem(index)} className="material-icons remove-item-icon">delete</i> */}
                                            </div>
                                            <div className="images-box" {...provided.dragHandleProps} tabIndex="-1">
                                                {item.image && item.image.sizes &&
                                                    <div className="image-wrapper">
                                                        <i className="material-icons" 
                                                            onClick={() => removeItem(item.image?.id ? item.image.id : null)}
                                                            aria-label="Usuń media"
                                                            tabIndex="0" 
                                                            role="button" 
                                                            onKeyDown={(e) => handleKeyDown(e, removeItem, item.image?.id ? item.image.id : null)}>close</i>
                                                        <img src={item.image.sizes.small} alt={item.image.alt} title={item.image.name} />
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    )}
                                </Draggable>
                            ))}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
            <div className="row-section">
                <MediaLoad forceValidate={ forceValidate } setFunction={ val => addItem(val)} value={props.data.items} only="image" type="gallery" items={props.data.items} removeItem={(id) => removeItem(id)} changeSelectedIndex={runChangeSelectedIndex} />
            </div>
        </div>
    );
}

export default Gallery;